import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface IProps {
  startTime: number;
  endTime: number;
  hourHeight: number;
}

export const CurrentTimeIndicator: React.FC<IProps> = ({ startTime, endTime, hourHeight }) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(interval);
  }, []);

  const currentHourDecimal = now.getHours() + now.getMinutes() / 60;
  const top = (currentHourDecimal - startTime) * hourHeight;

  // Hide if outside shop hours
  if (currentHourDecimal < startTime || currentHourDecimal >= endTime) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: `${top}px`,
        left: 0,
        right: 0,
        zIndex: 10,
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: 'error.main',
          flexShrink: 0,
          ml: '-5px',
          boxShadow: '0 0 6px 2px rgba(211,47,47,0.4)',
        }}
      />
      <Box
        sx={{
          flex: 1,
          height: '2px',
          background: 'linear-gradient(to right, rgba(211,47,47,0.9), rgba(211,47,47,0.3))',
        }}
      />
    </Box>
  );
};
